import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const carousel = document.querySelector('#bannerPromotionsCarousel');

if (carousel) {
	const slideCount = carousel.querySelectorAll('.swiper-slide').length;

	if (slideCount > 1) {
		new Swiper(carousel, {
			slidesPerView: 1,
			spaceBetween: 10,
			speed: 600,
			rewind: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: carousel.querySelector('.swiper-button-next'),
				prevEl: carousel.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				600: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
			},
		});
	}
}
